import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated } from './isAuthenticated';
import { ROUTES } from '../blocks/profileInfo/constant/Routes';

export const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (isAuthenticated() ? <Component {...props} /> : <Redirect to={ROUTES.SIGN_IN} />)} />
);
